module.exports = "<svg version=\"1.1\" baseProfile=\"tiny\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 210 210\" xml:space=\"preserve\"><path fill=\"#FFFFFF\" d=\"M180.5,148.3c-65.4,0-118.6-53.4-118.6-119.1H29.5c0,83.6,67.7,151.6,151,151.6V148.3z\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// /Users/jeroenbraspenning/Documents/02.PROCESS/CultuurEindhoven/cultuurprijs_website_2018/Development/eindhoven-cultuurprijs/~/svg-inline-loader!./assets/img/content/wallpaper_shape-2.svg
// module id = 35
// module chunks = 0